import lodash from 'lodash';

export const dataSourceEditorSelector = state => lodash.get(state, 'dataSourceEditor');

export const dataSourceSelector = state => lodash.get(dataSourceEditorSelector(state), 'dataSource');

export const dataSourceDataTypeSelector = state => lodash.get(dataSourceEditorSelector(state), 'dataSourceDataType');

export const dataSourceInitialSortOrderSelector = state => lodash.get(dataSourceEditorSelector(state), 'sortOrder');

export const dataSourceValuesSelector = state => lodash.get(dataSourceEditorSelector(state), 'values', []);

export const isSaveSuccessfulSelector = state => lodash.get(dataSourceEditorSelector(state), 'isSaveSuccessful');

export const isSubmittingSelector = state => lodash.get(dataSourceEditorSelector(state), 'isSubmitting', false);
